import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useId } from 'react';
export type StatusAilmentKey = 'poisoned' | 'burned' | 'paralyzed';

// 状態異常の選択肢を共通化
export const STATUS_AILMENT_OPTIONS: Array<{ key: StatusAilmentKey; label: string }> = [
  { key: 'poisoned', label: 'どく' },
  { key: 'burned', label: 'やけど' },
  { key: 'paralyzed', label: 'まひ' },
];

interface StatusAilmentSelectProps {
  value: StatusAilmentKey | 'none';
  onChange: (status: StatusAilmentKey | 'none') => void;
  label?: string;
  width?: string | number;
  size?: 'small' | 'medium';
  stopPropagation?: boolean;
}

function StatusAilmentSelect({
  value,
  onChange,
  label = '状態異常',
  width = '100%',
  size = 'small',
  stopPropagation,
}: StatusAilmentSelectProps) {
  const labelId = useId();

  return (
    <Box>
      <FormControl size={size} sx={{ width }}>
        <InputLabel id={labelId}>{label}</InputLabel>
        <Select
          labelId={labelId}
          value={value}
          label={label}
          onChange={(event) => onChange(event.target.value as StatusAilmentKey | 'none')}
          onClick={stopPropagation ? (event) => event.stopPropagation() : undefined}
        >
          <MenuItem value="none">なし</MenuItem>
          {STATUS_AILMENT_OPTIONS.map((status) => (
            <MenuItem key={status.key} value={status.key}>
              {status.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}

export default StatusAilmentSelect;
